 export function checkLicense(str){
    if(str.toUpperCase()==="A1"){
        return 0;
    } else if(str.toUpperCase()==="A2"){
        return 1;
    }
    else if(str.toUpperCase()==="A3"){
        return 2;
    }
    else if(str.toUpperCase()==="A4"){
        return 3;
    }
    else if(str.toUpperCase()==="B1"){
        return 4;
    }
    else if(str.toUpperCase()==="B2"){
        return 5;
    }
    else if(str.toUpperCase()==="C"){
        return 6;
    }
    else if(str.toUpperCase()==="D"){
        return 7;
    }
    else if(str.toUpperCase()==="E"){
        return 8;
    }
    else if(str.toUpperCase()==="F"){
        return 9;
    }
 }